import { LIST_TYPES, LIST_TYPE_ICONS } from "@tailormed/common-client/constant/savedList";

export const filtersTypes = { all: "all", private: "private", starred: "starred", shared: "shared" };
export const filtersTypesOptions = [
  {
    index: 1,
    key: filtersTypes.all,
    id: "saved_lists_all_lists_view",
    value: (t) => t("savedList.types_options.all")
  },
  {
    index: 2,
    key: filtersTypes.starred,
    id: "saved_lists_favorite_lists_view",
    value: (t) => t("savedList.types_options.favorite")
  },
  {
    index: 3,
    key: filtersTypes.private,
    id: "saved_lists_private_lists_view",
    value: (t) => t("savedList.types_options.private")
  },
  {
    index: 4,
    key: filtersTypes.shared,
    id: "saved_lists_homepage_shared_view",
    value: (t) => t("savedList.types_options.shared")
  }
];

export const PUBLIC = LIST_TYPES.PUBLIC;
export const PRIVATE = LIST_TYPES.PRIVATE;
export const SHARED = LIST_TYPES.SHARED;

export const getTypeIcon = (listType) => {
  const typeOption = LIST_TYPE_ICONS.find((option) => option.value === listType);

  if (!typeOption) return null;

  return {
    icon: typeOption.icon,
    title: typeOption.title,
    subtitle: typeOption.description,
    id: typeOption.id
  };
};
